import React, { useEffect, useState } from "react";
import { URDU_BOOKS_INDEX,ENGLISH_BOOKS_INDEX,ROR_INDEX,ALBADAR_INDEX, ALHAKAM_INDEX, ASK_ISLAM_INDEX, DARSUL_QURAN_INDEX, THIS_WEEK_WITH_HUZOOR_INDEX, BEACON_OF_GUIDANCE_INDEX, AL_REHMAT_INDEX, AL_FURQAN_INDEX, TASHEEZ_UL_AZHAN_INDEX, backendUrl, queryDetailPath,queryBookmarkPath, imageUrl, signedImageUrl } from '../../backendInfo';
import BaseModal from '../layout/BaseModal';
import MySpinner from '../layout/MySpinner';
import Cookies from 'js-cookie';
import axios from 'axios';
import { detailRequestParams } from '../../detailRequestParams';
import { itemInfo, getTextPresentation, showLivePDFButton, showPDFButton, showAudioBlock, showOpenLinkButton, showYoutubeLinkButton, getDetailItemInfoToggle, normaliseIndexName, signedUrl } from './ResultFunctions';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import Button from '@material-ui/core/Button';
import { HOLY_QURAN_INDEX } from "../../backendInfo";
import Bookmark from "../layout/Bookmark";
import { Grid } from "@material-ui/core";
import DisclaimerText from "../layout/disclaimerText";
import langdata from "../../constants/langdata";
import { queryUrl } from "../../backendInfo";
import HuzoorQaText from './HuzoorQaText';


export const hQDetailItemStyles = {
    marginBottom: '18px',
    borderRadius: '8px',
    border: '1px solid #f3f3f4',
    boxShadow: '1px 1px 2px #f3f3f3',
    padding: '6px'
}


export const getHQDetailItemInfoStyles = lang => {
    if (lang === 'urdu'){
        return {
            display: 'block',
            textAlign: 'right',
            color: '#919191'
        }
    }
    else if (lang === 'en'){
        return {
            display: 'block',
            textAlign: 'left',
            color: '#919191'
        }
    }
}


const makePrevQueryParams = queryParams => {
    if((queryParams.tab === 'books' || queryParams.tab === 'new_urdu_books' || queryParams.tab === 'new_english_books') && queryParams.page_number){
        return {...queryParams, page_number: queryParams.page_number - 1}
    }
    else if(queryParams.page_no){
        return {...queryParams, page_no: queryParams.page_no - 1}
    }
    else if(queryParams.para_no){
        return {...queryParams, para_no: queryParams.para_no - 1}
    }
    else if(queryParams.verse){
        return {...queryParams, verse: queryParams.verse - 1}
    }
    return queryParams
}


const makeNextQueryParams = queryParams => {
    if((queryParams.tab === 'books' || queryParams.tab === 'new_urdu_books' || queryParams.tab === 'new_english_books') && queryParams.page_number){
        return {...queryParams, page_number: queryParams.page_number + 1}
    }
    else if(queryParams.page_no){
        return {...queryParams, page_no: queryParams.page_no + 1}
    }
    else if(queryParams.para_no){
        return {...queryParams, para_no: queryParams.para_no + 1}
    }
    else if(queryParams.verse){
        return {...queryParams, verse: queryParams.verse + 1}
    }
    return queryParams
}


const OpenBookPageButton = ({ url, queryParams }) => {
    const [buttonUrl, setButtonUrl] = useState('');
    const [text, setText] = useState('');

    useEffect(() => {
        const fetchUrl = async () => {
            const access = Cookies.get('token');

            if (signedUrl(queryParams) && String(access) !== "null") {
                try {
                    const res = await axios.post(
                        `${backendUrl}${queryUrl}`,
                        { queryParams },
                        { headers: { Authorization: `Bearer ${access}` } }
                    );

                    if (res.data && res.data.signed_url) {
                        setButtonUrl(res.data.signed_url);
                    }
                } catch (error) {
                    console.error('Error fetching URL:', error);
                    // Optional: Provide feedback to the user
                }
            } else {
                setButtonUrl(url); // Fallback to the initial URL if token is null
            }
        };

        setText(langdata[localStorage.getItem('lang-pref')]['buttons']['Open page in Book']);
        fetchUrl();
    }, [queryParams]); // Remove 'url' if it's not required to trigger fetching

    return (
        <a
            id="openInBookBtn"
            className="btn btn-small"
            href={buttonUrl || url} // Use buttonUrl if set, otherwise fallback to `url`
            target="_blank"
            rel="noopener noreferrer"
        >
            {text}
        </a>
    );
};



const OpenOriginalLinkButton = ({ url }) => {
    return <a 
            id="OpenOriginalLinkButton" 
            className="btn btn-small" 
            href={url} 
            target="_blank" 
            rel="noopener noreferrer"
            >{langdata[localStorage.getItem('lang-pref')]['buttons']['Open Original Link']}</a>
}

const OpenYoutubeLinkButton = ({ url }) => {
    return <a
            id="OpenYoutubeLinkButton"
            className="btn btn-small" 
            href={url} 
            target="_blank" 
            rel="noopener noreferrer"
            >{langdata[localStorage.getItem('lang-pref')]['buttons']['Open Youtube link']}</a>
}

const PlayAudio = ({ audioUri }) => {
    return <audio id="audioBlock" controls src={audioUri}  />
}

const ImageZoomModal = ({ isOpen, onClose, imagePath, queryParams, fetchDetail, handleImageResponse, setCurrParams }) => {
    const [signedUrl, setSignedUrl] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)
    const [currentImagePath, setCurrentImagePath] = useState(imagePath)
    const [currentQueryParams, setCurrentQueryParams] = useState(queryParams)

    const fetchSignedUrl = async (path) => {
        setLoading(true)
        setError(false)
        try {
            const response = await axios.get(
                `${backendUrl}${signedImageUrl}`,
                {
                    params: { image_path: path }
                }
            )
            if (response.data && response.data.signed_url) {
                setSignedUrl(response.data.signed_url)
            }
        } catch (error) {
            console.error('Error fetching signed URL:', error)
            setError(true)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        // Only initialize when modal opens, not when imagePath changes during navigation
        if (isOpen) {
            setCurrentImagePath(imagePath)
            setCurrentQueryParams(queryParams)
            if (imagePath) {
                fetchSignedUrl(imagePath)
            }
        }
    }, [isOpen]) // Only depend on isOpen to initialize once when modal opens

    useEffect(() => {
        const handleKeyPress = (e) => {
            if (!isOpen) return

            if (e.key === 'ArrowLeft') {
                navigateImage('next')
            } else if (e.key === 'ArrowRight') {
                navigateImage('prev')
            } else if (e.key === 'Escape') {
                onClose()
            }
        }

        if (isOpen) {
            window.addEventListener('keydown', handleKeyPress)
        }

        return () => {
            window.removeEventListener('keydown', handleKeyPress)
        }
    }, [isOpen, currentQueryParams])

    const navigateImage = (direction) => {
        setCurrentQueryParams(prevParams => {
            const newParams = direction === 'next'
                ? makeNextQueryParams(prevParams)
                : makePrevQueryParams(prevParams)

            fetchDetail(newParams, (res) => {
                const newImagePath = handleImageResponse(res)
                if (newImagePath) {
                    setCurrentImagePath(newImagePath)
                    setCurrParams(newParams)
                    fetchSignedUrl(newImagePath)
                }
            })

            return newParams
        })
    }

    if (!isOpen) return null

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.9)',
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column'
            }}
            onClick={onClose}
        >
            <button
                onClick={onClose}
                style={{
                    position: 'absolute',
                    top: '20px',
                    right: '20px',
                    backgroundColor: 'white',
                    border: 'none',
                    borderRadius: '50%',
                    width: '40px',
                    height: '40px',
                    fontSize: '24px',
                    cursor: 'pointer',
                    zIndex: 10000
                }}
            >
                ×
            </button>

            {currentQueryParams.page_number && (
                <div
                    style={{
                        position: 'absolute',
                        top: '20px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        padding: '8px 16px',
                        borderRadius: '20px',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        zIndex: 10000
                    }}
                >
                    Page {currentQueryParams.page_number}
                </div>
            )}

            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    height: '100%',
                    position: 'relative'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    onClick={() => navigateImage('next')}
                    style={{
                        position: 'absolute',
                        left: '20px',
                        backgroundColor: 'white',
                        border: 'none',
                        borderRadius: '50%',
                        width: '50px',
                        height: '50px',
                        fontSize: '24px',
                        cursor: 'pointer',
                        zIndex: 10000
                    }}
                >
                    ›
                </button>

                {loading ? (
                    <div style={{ color: 'white', fontSize: '20px' }}>Loading image...</div>
                ) : error || !signedUrl ? (
                    <div style={{ color: 'white', fontSize: '20px' }}>Error loading image</div>
                ) : (
                    <img
                        src={signedUrl}
                        alt="Book page zoomed"
                        style={{
                            maxWidth: '90%',
                            maxHeight: '90%',
                            objectFit: 'contain'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    />
                )}

                <button
                    onClick={() => navigateImage('prev')}
                    style={{
                        position: 'absolute',
                        right: '20px',
                        backgroundColor: 'white',
                        border: 'none',
                        borderRadius: '50%',
                        width: '50px',
                        height: '50px',
                        fontSize: '24px',
                        cursor: 'pointer',
                        zIndex: 10000
                    }}
                >
                    ‹
                </button>
            </div>
        </div>
    )
}

const SignedImageDisplay = ({ imagePath, onClick }) => {
    const [signedUrl, setSignedUrl] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)

    useEffect(() => {
        const fetchSignedUrl = async () => {
            try {
                const response = await axios.get(
                    `${backendUrl}${signedImageUrl}`,
                    {
                        params: { image_path: imagePath }
                    }
                )
                if (response.data && response.data.signed_url) {
                    setSignedUrl(response.data.signed_url)
                }
            } catch (error) {
                console.error('Error fetching signed URL:', error)
                setError(true)
            } finally {
                setLoading(false)
            }
        }

        if (imagePath) {
            fetchSignedUrl()
        }
    }, [imagePath])

    if (loading) {
        return (
            <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                <div style={{ padding: '20px', color: '#919191' }}>Loading image...</div>
            </div>
        )
    }

    if (error || !signedUrl) {
        return null
    }

    return (
        <div style={{ marginBottom: '20px', textAlign: 'center' }}>
            <img
                src={signedUrl}
                alt="Book page"
                style={{
                    maxWidth: '60%',
                    maxHeight: '500px',
                    height: 'auto',
                    border: '1px solid #f3f3f4',
                    borderRadius: '8px',
                    boxShadow: '1px 1px 2px #f3f3f3',
                    cursor: 'pointer'
                }}
                onClick={onClick}
                onError={(e) => {
                    e.target.style.display = 'none'
                }}
            />
        </div>
    )
}


// const OpenLivePageButton = ({ url }) => {
//     return <a 
//             id="openInPDFBtn" 
//             className="btn btn-small" 
//             href={url} 
//             target="_blank" 
//             rel="noopener noreferrer"
//             >Open page on Al-Islam</a>
// }


const EmptyPageMessage = () => {
    return <>
        <p style={{
            textAlign: 'center', 
            color:'#979797',
            paddingTop: '25%'
            }}>We're sorry, but we couldn't find that page.</p>
    </>
}


const Title = ({ queryParams, index  }) => {
    const textPresentation = getTextPresentation(queryParams.lang, index)
    // Flex row: title text takes the free space, action buttons sit together
    // at the far end and wrap as a group on narrow screens (works in RTL too).
    return <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
        <span
            className={textPresentation.className}
            dir={textPresentation.dir}
            lang={textPresentation.lang}
            style={{ flex: '1 1 auto', minWidth: '200px' }}
        >{ itemInfo(queryParams, index) }</span>
        { showPDFButton(queryParams, index) && <OpenBookPageButton url={queryParams.url} queryParams={queryParams} /> }
        {/* { showLivePDFButton(queryParams) && <OpenLivePageButton url={queryParams.url_live}/>} */}
        { showOpenLinkButton(queryParams, index) && <OpenOriginalLinkButton url={queryParams.ask_islam_link || queryParams.url}/>}
        { showYoutubeLinkButton(queryParams, index) && <OpenYoutubeLinkButton url={queryParams.timestamp_link || queryParams.youtube_link}/>}
        {/* { showAudioBlock(index) && <PlayAudio audioUri={queryParams.mp3_link}/>} */}

    </div>
}


const ScrollButton = props => {
    const { previous, queryParams, fetchDetail, handleResponse, setCurrParams} = props
    const icon = previous ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />
    

    // const label = previous ? "Previous Page" : "Next Page"
    const displayLabel = previous ? langdata[localStorage.getItem('lang-pref')]['buttons']['Previous'] :langdata[localStorage.getItem('lang-pref')]['buttons']['Next'];
    let label;
    if (queryParams.tab === 'friday_sermon' || queryParams.tab === 'friday_sermon_new') {
        label = `${displayLabel} ${langdata[localStorage.getItem('lang-pref')]['buttons']['Paragraph']}`;
    } else {
        label = `${displayLabel} ${langdata[localStorage.getItem('lang-pref')]['buttons']['Page']}`;
    }

    return <Button
            size="small"
            variant="contained"
            style={{ 
                display:"flex", 
                margin:"auto",
                marginTop: previous ? "auto" : "20px" 
            }} 
            onClick={() => {
                setCurrParams(queryParams)
                fetchDetail(queryParams, handleResponse)
            }}
            startIcon={icon}
        >
        {label}
    </Button>
}


const ContentHolder = props => {
    // props.content : list of elements
    const {
        content,
        showPrev,
        showNext,
        prevButton,
        nextButton,
        imagePath,
        indexName,
        onImageClick
    } = props

    return content.length > 0 ? (
        <>
            { showPrev && prevButton }
            {(indexName === URDU_BOOKS_INDEX || indexName === ENGLISH_BOOKS_INDEX || indexName === AL_REHMAT_INDEX || indexName === AL_FURQAN_INDEX || indexName === TASHEEZ_UL_AZHAN_INDEX) && imagePath && (
                <SignedImageDisplay imagePath={imagePath} onClick={onImageClick} />
            )}
            <div className="detail-content">
                { content }
            </div>
            { showNext && nextButton }
        </>
    ) : <MySpinner display={true}/>

}


export const HitRenderer = ({ hit }) => {
    // Data-specific complexity in here
    const indexName = normaliseIndexName(hit._index)

    //Render Hit here
    if([THIS_WEEK_WITH_HUZOOR_INDEX, BEACON_OF_GUIDANCE_INDEX].includes(indexName)){
        return <HuzoorQaText hit={hit}/>
    }
    else if(hit._index === HOLY_QURAN_INDEX){
            let elements = []
            const fieldNumbers = [1,2,3,4,5,6,7,8,9]
            
            elements = elements.concat(
                <p
                key={hit._id} 
                className="hQArabicText"
                style={{ marginTop: '50px' }}
                dangerouslySetInnerHTML={{__html: hit._source.arabic}}
                ></p>
            )
            
            elements = elements.concat(fieldNumbers.map(num => {
                const textField = `col${num}`
                const infoField = `col${num}_info`
                const langField = `col${num}_lang`
                const text = hit.highlight && 
                            Object.keys(hit.highlight).includes(textField)
                            ? hit.highlight[textField][0] : hit._source[textField]
                
                if (hit._source[textField] !== null){
                    const textPresentation = getTextPresentation(hit._source[langField], HOLY_QURAN_INDEX)
                    return <div key={hit._id + textField} style={hQDetailItemStyles}>
                            <p 
                            dangerouslySetInnerHTML={{__html: text}} 
                            className={textPresentation.className}
                            dir={textPresentation.dir}
                            lang={textPresentation.lang}
                            >
                            </p>
                            <span
                            className={textPresentation.className}
                            dir={textPresentation.dir}
                            lang={textPresentation.lang}
                            style={getHQDetailItemInfoStyles(hit._source[langField])}
                            >
                            {hit._source[infoField]}
                            </span>
                        </div>
                }
                
            }))

            return elements
        }
    // else if(  ){
    //     const hitText = hit.highlight ? hit.highlight.text[0] : hit._source.text
    //     return <>
    //             <p 
    //             className={getTextClass(hit._source.lang)}
    //             dangerouslySetInnerHTML={{__html: hitText}}     
    //             ></p>
    //         </>
    //     }
    else{
        const hitText = hit.highlight ? hit.highlight.text[0].replace(/\n/g, '<br>') : hit._source.text.replace(/\n/g, '<br>')
        const textPresentation = getTextPresentation(hit._source.lang, indexName)
        return <>
                <p
                className={textPresentation.className}
                dir={textPresentation.dir}
                lang={textPresentation.lang}
                dangerouslySetInnerHTML={{__html: hitText}}
                ></p>
                {getDetailItemInfoToggle(indexName) &&
                    <p
                    className="width-content margin-auto"
                    >{itemInfo(hit._source, indexName)}</p>
                }
            </>
    }
}


const NewResultDetails = ({ isOpen, onClose, queryParams }) => {
    const [content, setContent] = useState([])
    const [showNextButton, toggleNextButton] = useState(true)
    const [showPrevButton, togglePrevButton] = useState(true)
    const [indexName, setIndexName] = useState(null)
    const [currQueryParams, setCurrQueryParams] = useState(queryParams)
    const [saved,setSaved]=useState(false)
    const [imageUrl, setImageUrl] = useState(null)
    const [imageLoading, setImageLoading] = useState(false)
    const [imagePath, setImagePath] = useState(null)
    const [isZoomOpen, setIsZoomOpen] = useState(false)
   
    
    
   
    const saveDetail=(queryParams) => {
        const access = Cookies.get('token');
        if(String(access) !== "null"){          
            axios.post(
                `${backendUrl}${queryBookmarkPath}`,
                { 
                    params: queryParams, 
                },
                  {  headers: { Authorization: `Bearer ${access}` } }
            )
            .then(res => {
                setSaved(true)
            })
        }
        else{}
       
    }

    const fetchImage = async (imagePath) => {
        if (!imagePath) return

        setImageLoading(true)
        try {
            const access = Cookies.get('token');
            if (String(access) !== "null") {
                const response = await axios.get(
                    `${backendUrl}${imageUrl}`,
                    {
                        params: { image_path: imagePath },
                        headers: { Authorization: `Bearer ${access}` },
                        responseType: 'blob'
                    }
                )

                if (response.status === 200) {
                    const imageBlob = response.data
                    const imageBlobUrl = URL.createObjectURL(imageBlob)
                    setImageUrl(imageBlobUrl)
                }
            }
        } catch (error) {
            console.error('Error fetching image:', error)
        } finally {
            setImageLoading(false)
        }
    }

    const fetchDetail = (queryParams, handleResponse) => {
        const access = Cookies.get('token');
        if(String(access) !== "null"){
            axios.get(
                `${backendUrl}${queryDetailPath}`,
                {
                    params: detailRequestParams(queryParams),
                    headers: { Authorization: `Bearer ${access}` }
                }
            )
            .then(res => {
                handleResponse(res)
            })
        }
        else{}
    }

    const handleResponse = res => {
        let hits = res.data.hits.hits
        // Reset image path for new results
        setImagePath(null)

        let newImagePath = null
        let elements = Object.values(hits).map(
            hit => {
                !indexName && setIndexName(normaliseIndexName(hit._index))
                if ((hit._index === URDU_BOOKS_INDEX || hit._index === ENGLISH_BOOKS_INDEX || hit._index === AL_REHMAT_INDEX || hit._index === AL_FURQAN_INDEX || hit._index === TASHEEZ_UL_AZHAN_INDEX) && hit._source.image_path && !newImagePath) {
                    newImagePath = hit._source.image_path
                }
                return <HitRenderer hit={hit} key={ hit._id } />
            }
        )

        // Set the new image path after processing all hits
        if (newImagePath) {
            setImagePath(newImagePath)
        }

        if (elements.length > 0)
            setContent(elements)
        else
            setContent([<EmptyPageMessage key={'5xkw25m^l2'}/>])
    }

    const handleImageResponse = res => {
        let hits = res.data.hits.hits
        let newImagePath = null

        Object.values(hits).forEach(hit => {
            if ((hit._index === URDU_BOOKS_INDEX || hit._index === ENGLISH_BOOKS_INDEX || hit._index === AL_REHMAT_INDEX || hit._index === AL_FURQAN_INDEX || hit._index === TASHEEZ_UL_AZHAN_INDEX) && hit._source.image_path && !newImagePath) {
                newImagePath = hit._source.image_path
            }
        })

        return newImagePath
    }

    const updatePageConfigs = () => {
        if (indexName && indexName === ASK_ISLAM_INDEX){
            toggleNextButton(false)
            togglePrevButton(false)
        }
        else if (indexName && indexName === DARSUL_QURAN_INDEX){
            toggleNextButton(false)
            togglePrevButton(false)
        }
        else if (indexName && [THIS_WEEK_WITH_HUZOOR_INDEX, BEACON_OF_GUIDANCE_INDEX].includes(indexName)){
            toggleNextButton(false)
            togglePrevButton(false)
        }
        // else if (indexName && indexName === ALBADAR_INDEX){
        //     toggleNextButton(false)
        //     togglePrevButton(false)
        // }
        // else if (indexName && indexName === ALHAKAM)_INDEX){
        //     toggleNextButton(false)
        //     togglePrevButton(false)
        // }
        else{

        }
    }

    useEffect(() => {
        fetchDetail(currQueryParams, handleResponse)
        updatePageConfigs()

        return () => {
            if (imageUrl && imageUrl.startsWith('blob:')) {
                URL.revokeObjectURL(imageUrl)
            }
        }
    }, [])

    useEffect(() => {
        updatePageConfigs()
    }, [indexName])

    return isOpen ? (
        <>
            <ImageZoomModal
                isOpen={isZoomOpen}
                onClose={() => setIsZoomOpen(false)}
                imagePath={imagePath}
                queryParams={currQueryParams}
                fetchDetail={fetchDetail}
                handleImageResponse={handleImageResponse}
                setCurrParams={setCurrQueryParams}
            />
            <BaseModal
                content={
                    <ContentHolder
                        content={content}
                        showPrev={showPrevButton}
                        showNext={showNextButton}
                        imagePath={imagePath}
                        indexName={indexName}
                        onImageClick={() => setIsZoomOpen(true)}
                        prevButton={
                            <ScrollButton
                                previous={true}
                                queryParams={makePrevQueryParams(currQueryParams)}
                                handleResponse={handleResponse}
                                setCurrParams={setCurrQueryParams}
                                fetchDetail={fetchDetail}
                            />}
                        nextButton={
                            <ScrollButton
                                queryParams={makeNextQueryParams(currQueryParams)}
                                handleResponse={handleResponse}
                                setCurrParams={setCurrQueryParams}
                                fetchDetail={fetchDetail}
                            />
                        }
                    />
                }
                title={
                <Grid container alignItems="center" justifyContent="space-between" spacing={3}>
                 <Grid item xs={indexName === URDU_BOOKS_INDEX ? 12 : 11}> {/* Adjust the size of the Title item */}
                    <Title index={indexName} queryParams={currQueryParams}/>
                </Grid>
                <Grid xs={indexName === URDU_BOOKS_INDEX ? 0 : 1} style={{textAlign:'center'}}> {/* Adjust the size of the Bookmark item */}
                    
                {indexName !== URDU_BOOKS_INDEX && <Bookmark isSaved={saved} onClick={() => saveDetail(currQueryParams)} />}
                </Grid>
            </Grid>}
                isOpen={isOpen} 
                handleClose={onClose}
                titlePosition="bottom"
                disclaimer={<DisclaimerText index={indexName}/>}
                
                imageUrl={imageUrl || (indexName === ROR_INDEX && currQueryParams?.past_url ? currQueryParams.url : null)}

            />
        </>
    ) : null

}


export default NewResultDetails;
